import styled from 'styled-components';
import {Select} from 'antd';
import DebouncedInput from '../../../../DebouncedInput';
import CompanyTagSelect from '../../../TransactionsPage/CompanyTagSelect';

const StyledAllTabInput = styled(DebouncedInput)`
  min-width: 100px;
  width: max-content;
  padding-left: 0;
`;

const StyledAllTabCompanyTagSelect = styled(CompanyTagSelect)`
  min-width: 150px;
  .ant-input-affix-wrapper {
    background-color: transparent;
    border: none !important;
    box-shadow: none !important;
    & > .ant-input {
      background-color: transparent;
      font-size: 14px;
    }
  }
  .ant-dropdown-trigger {
    font-size: 14px;
  }
`;

const StyledAllTabSelect = styled(Select)`
  &.ant-select-single.ant-select-lg {
    width: 32px;

    .ant-select-selector {
      border: none !important;
      box-shadow: none !important;
      height: 32px;
      padding: 0;

      .ant-select-selection-item {
        line-height: 32px;

        .ant-space-item {
          &:nth-child(2) {
            display: none;
          }
        }
      }
    }
  }
`;

export {
  StyledAllTabInput,
  StyledAllTabSelect,
  StyledAllTabCompanyTagSelect
}
